import {Component, OnInit, ViewChild} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import swal from "sweetalert2";
import {InventoryService} from '../../../service/inventory.service';
import {Inventory} from '../../../model/invantory.model';
import {InventoryDetailsComponent} from '../inventory-details.component';

@Component({
  selector: 'app-edit-inventry-details',
  templateUrl: './edit-inventry-details.component.html',
  styleUrls: ['./edit-inventry-details.component.scss']
})
export class EditInventryDetailsComponent implements OnInit {
  public inventoryFormDetails: FormGroup;
  public inventoryDetails:any = {
    openingQty:0,
    totalAddedQty:0,
    reOrderLevel:0,
    Cancel:0,
    Issued:0,
    Returned:0,
    Available:0,
  };

  constructor(public activeModal: NgbActiveModal,
              public inventory_service: InventoryService) { }

  ngOnInit() {
    this.getLastInventoryDetails();
    this.getCardsCount();
    this.inventoryFormDetails = new FormGroup({
      openingQty: new FormControl(null,[Validators.required]),
      totalAddedQty: new FormControl(null,[Validators.required]),
      availableStockQty: new FormControl(null,[Validators.required]),
      reOrderLevel: new FormControl(null,[Validators.required]),
    });
  }

  updateValues(data){
    swal.fire({
      title: "Are you sure, Do you want to update?",
      text: "",
      showCancelButton: true,
      confirmButtonText: "Yes"
    }).then((result)=> {

      let inventory: Inventory = {
        openingQty : (data.openingQty != null) ? this.inventoryDetails.openingQty+ data.openingQty : this.inventoryDetails.openingQty ,
        totalAddedQty: (data.totalAddedQty != null) ? this.inventoryDetails.totalAddedQty+ data.totalAddedQty : this.inventoryDetails.totalAddedQty ,
        totalReturnedQty: this.inventoryDetails.Returned,
        totalIssuedQty: this.inventoryDetails.Issued,
        totalCancelQty: this.inventoryDetails.Cancel,
        availableStockQty: (data.availableStockQty != null) ? data.availableStockQty : this.inventoryDetails.availableStockQty ,
        reOrderLevel: (data.reOrderLevel != null) ? data.reOrderLevel : this.inventoryDetails.reOrderLevel ,
      };

      this.inventory_service.saveInventory(inventory).subscribe(
        (data) => {
          this.getLastInventoryDetails();
          this.getCardsCount();
          swal.fire("Success", "Card cancelled successfully", "success");
        },
        (error) => {
          console.error(error);
          swal.fire("Error", "Error in Inventory details update", "error");
        },()=>{
          this.activeModal.dismiss();
        });

    });
  }

  getLastInventoryDetails(){
    this.inventory_service.getLastInventory().subscribe(
      (data:any)=>{
        this.inventoryDetails.totalAddedQty = data.totalAddedQty;
        this.inventoryDetails.reOrderLevel = data.reOrderLevel;
        this.inventoryDetails.openingQty = data.openingQty;
        // this.inventoryFormDetails.patchValue(data);
      },
      (error)=>{
        swal.fire("Error", "Error in loading inventory details", "error");
      });
  }

  getCardsCount(){
    this.inventory_service.getCarCountByStatus().subscribe(
      (data:any)=>{
        // console.log(data,"data");
          this.inventoryDetails.Returned = data.Returned;
          this.inventoryDetails.Issued = data.Issued;
          this.inventoryDetails.Cancel = data.Cancel;
      },
      (error)=>{
        swal.fire("Error", "Error in loading inventory details", "error");
      });
  }

}
